import { render, staticRenderFns } from "./IntroXVisor.vue?vue&type=template&id=07d36df8&"
import script from "./IntroXVisor.vue?vue&type=script&lang=js&"
export * from "./IntroXVisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports